import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/** @param {{ query?: object }} [option] */
export const GetPerformance = async (option) => {
  const response = await $api.get(
    Endpoints.LeadAdvertisementReport.GetPerformance(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: object }} [option] */
export const GetPerformanceDetails = async (option) => {
  const response = await $api.get(
    Endpoints.LeadAdvertisementReport.GetPerformanceDetails(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: object }} [option] */
export const GetTags = async (option) => {
  const response = await $api.get(
    Endpoints.LeadAdvertisementReport.GetTags(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: object }} [option] */
export const GetTagDetails = async (option) => {
  const response = await $api.get(
    Endpoints.LeadAdvertisementReport.GetTagDetails(option)
  );
  return ResponseChecker(defaultMessages, response);
};

export const GetSummary = async (option) => {
  const response = await $api.get(
    Endpoints.LeadAdvertisementReport.GetSummary(option)
  );
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetSummary,
  GetPerformance,
  GetPerformanceDetails,
  GetTags,
  GetTagDetails,
};
